import loggedinView from './headerLoggedinView.html';
import defaultThemeData from 'components/sharpr/theme/defaultThemeData';

export default function loggedinComponent() {
	return {
		restrict: 'E',
		scope: {},
		transclude: true,
		bindToController: {
			title: '@',
			subtitle: '@',
			onAddContent: '&',
		},
		controllerAs: 'vm',
		controller: loggedinComponentCtrl,
		template: loggedinView,
	};
}

class loggedinComponentCtrl {
	constructor($window, Cfg, Theme, $state) {
		'ngInject';
		this.Theme = Theme;
		this.Cfg = Cfg;
		this.$window = $window;
		this.$state = $state;
		this.showNotifications = this.Cfg.readAsBool('Features.show_notifications');
		this.setup();
		this.siteNavOpen = false;

		this.displayKnowledgebaseLink = Boolean(Number(this.Cfg.read('KnowledgebaseLink.Display')));
		this.knowledgebaseLinkUrl = '';

		if (window.location.pathname === '/hub') {
			if (/^#?\/preferences\/auto_emails(\b|$)/i.test(window.location.hash)) {
				this.knowledgebaseLinkUrl = Cfg.read('KnowledgebaseLink.AutomatedAlerts.Page');
			} else if (/^#?\/admin\/users(\b|$)/i.test(window.location.hash)) {
				this.knowledgebaseLinkUrl = Cfg.read('KnowledgebaseLink.Admin.Page');
			} else if (/^#?\/emails(\b|$)/i.test(window.location.hash)) {
				this.knowledgebaseLinkUrl = Cfg.read('KnowledgebaseLink.ExistingEmails.Page');
			}
		}
	}

	setup() {
		// logo
		this.themeData = this.Theme.data() || defaultThemeData;
		this.logo = {
			url: this.themeData.header == 'black' ? this.themeData.on_dark_url : this.themeData.on_light_url,
		};
	}

	submitOrClearSearch() {
		this.onSearchUpdate();
	}

	headerLogoClick() {
		let homePage = this.Cfg.read('Features.home_page');

		//Just in case they are trying to use the classic insights page
		if (this.Cfg.readAsBool('UI.use_classic_insights_page') && homePage.includes('core/insights')) {
			homePage = '/hub#/posts';
		}
		// System setting default is '/hub#/posts', should always have a homepage, just in-case they dont, take them to insights page
		if (!homePage) {
			this.$window.location.href = `${this.$window.BASE_URL}/hub#/posts`;
		}

		const windowHref = this.$window.location.href;
		if (homePage.includes('/hub#/posts') && windowHref.includes('/hub#/posts')) {
			// User has a hub setting set to '/hub#/posts' and is currently on the insights page.
			// A reload here is necessary to clear out any type of search: term, category, etc.
			this.$state.reload();
		} else {
			this.$window.location.href = `${this.$window.BASE_URL}${homePage}`;
		}
	}

	contentAdded(post) {
		this.onAddContent({ $post: post });
	}
}
